<template>
	<div class="org-container">
		<el-button type="success" @click="syncChinaRegion">同步全国省市区</el-button>
		<el-button type="success" @click="getSyncFoundationModel">同步火山方舟公开模型列表</el-button>

	</div>
</template>

<script>
	export default {
		name: '',

		data() {
			return {
				login: null
			}
		},
		methods: {
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text: text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close()
					this.login = null
				}
			},
			syncChinaRegion() {
				this.API.post(this.API.admin.postSyncChina).then(res => {
					console.log('res', res.data)
				})
			},
			async getSyncFoundationModel() {
				this.loginOpen('火山模型更新中...')
				try {
					let res = await this.API.get(this.API.fileurl.getSyncFoundationModel)
					if (res.data.code == 200) {
						this.$message.success('更新成功')
						
					}
				} catch (e) {
					this.$message.error('更新失败')
				} finally {
					this.noLogin()
				}
			},
		},
	}
</script>

<style scoped>
	.org-container {
		background: #fff;
		padding: 20px;
		border-radius: 8px;
		height: 100%;
		box-sizing: border-box;
	}

	.menu-tabs {
		margin-bottom: 20px;
	}

	.menu-tabs .el-button {
		margin-right: 10px;
	}
</style>